import { useMainStore } from '@/stores/MainStore.js'

export const createShowMessage = () => ({
  install(app) {
    app.config.globalProperties.$showMessage = function (message, options = {}) {
      const snack = {
        message: message,
      };

      switch (options.type) {
        case 'info':
          snack.color = 'info';
          break;
        case 'warning':
          snack.color = 'warning';
          break;
        case 'error':
          snack.color = 'error';
          break;

        default:
          snack.color = 'success';
          break;
      }

      if (options.color) {
        snack.color = options.color;
      }

      const mainStore = useMainStore();
      mainStore.createSnackbar(snack);
    };
  },
});
